import React from 'react';
import YouTube from 'react-youtube'

export default function YouTubeWrapper({videoId}) {
  const opts = {
    // height: '390',
    width: '100%',
    // playerVars: {
    //   // https://developers.google.com/youtube/player_parameters
    //   autoplay: 1,
    // },
  };

  // @ts-ignore
  return <YouTube style={{alignSelf:"center"}} videoId={videoId} opts={opts} />;
}
